<template>
  <div class="row">

    <div class="col-xs-12">
      <h2>Etude du Web Français Bdx : Synthèse des préconisations </h2>
    </div>

    <div class="col-xs-12 mt-30 mb-30" v-if="quiz">
      <!-- BEGIN VALIDATION STATES-->
      <div class="portlet light portlet-fit portlet-form bordered col-xs-12 p-0 ">
          <div class="portlet-title col-xs-12 ">
              <div class="caption tabbable-line p-0">
                  <ul class="nav nav-tabs ">
                      <li class="active">
                          <a data-toggle="tab" aria-expanded="false" v-on:click="show.table = true">
                            <i class=" icon-layers"></i>
                            <span class="caption-subject sbold uppercase">Tableau </span>
                          </a>
                      </li>
                      <li class="">
                          <a data-toggle="tab" aria-expanded="true" v-on:click="show.report = true">
                            <i class=" icon-note"></i>
                            <span class="caption-subject sbold uppercase">Rapport</span>
                          </a>
                      </li>
                  </ul>
              </div>
          </div>

          <div class="portlet-body col-xs-12 mb-30">

            <list v-show="show.table" class="mt-30" :columns="columns" :dataSet="dataSet"></list>

            <div v-show="show.report" class="col-xs-12">
              <report-preconization :preconizations.sync="preconizations"></report-preconization>
            </div>

            <a v-on:click="$router.back()" class="btn btn-circle default mt-20 ml-10">
              <i class="fa fa-arrow-left"></i>
               Retour
            </a>

          </div>
      </div>

    </div>

    <div class="row m-0" v-else>
      <div class="col-md-12 page-404 mt-50 pb-50">
          <div class="number font-green"> 404 </div>
          <div class="details">
              <h3>Oops ! Questionnaire non trouvé.</h3>
              <p> Nous n'avons pas réussi à trouver ce questionnaire.
                  <br>
                  Vérifiez'url et tentez de recharger la page.
              </p>
          </div>
      </div>
    </div>


  </div>
</template>

<script>

  import List from '../../others/list.vue'
  import quizzes from '../../../requests/quizzes.js'
  import ReportPreconization from '../../others/report_preconization.vue'

  export default {
    created () {
    },
    components: {
      List,
      ReportPreconization
    },
    props: [],
    data(){
      return{
        dataSet:[],
        columns:[],
        show:{
          table:true,
          report:false
        },
        quiz:{},
        preconizations:[]
      }
    },
    watch:{
      'show.table':function(){
        if(this.show.table){
          this.show.report = false;
        }
      },
      'show.report':function(){
        if(this.show.report){
          this.show.table = false;
        }
      }
    },
    mounted:function(){
      var parent = this;
      quizzes.getBySlug(this,this.$route.params.slug,function(quiz,err){
        if(quiz){
          parent.quiz = quiz;
          parent.getData();
        }
        else{
          parent.quiz = null;
          toastr.error("Impossible de récupérer le questionnaire.","ERREUR");
        }
      })
    },
    methods:{
      showData(preconizations){
        var parent = this;
        parent.dataSet = [];
        // console.log("show data",quizzes.length);
        for(var a=0;a<preconizations.length;a++){
            var tr = [];
            tr.push("<span class='preconisation_line'>"+preconizations[a].number+"</span>");
            tr.push("<span class='preconisation_line'>"+preconizations[a].title+"</span>");
            tr.push("<span class='preconisation_line'>"+preconizations[a].description+"</span>");
            tr.push("<span class='preconisation_line'></span>");
            parent.dataSet.push(tr);

            for(var i=0;i<preconizations[a].actions.length;i++){
              tr = [];
              tr.push(preconizations[a].actions[i].number);
              tr.push(preconizations[a].actions[i].title);
              tr.push(preconizations[a].actions[i].description);
              tr.push(preconizations[a].actions[i].deadline);
              parent.dataSet.push(tr);
            }
        }

        parent.columns = [];
        parent.columns.push({title:"N°"});
        parent.columns.push({title:"Titre"});
        parent.columns.push({title:"Description"});
        parent.columns.push({title:"Délai de réalisation"});
      },
      getData(){
        var parent = this;
        quizzes.getPreconizations(this,this.$route.params.slug,function(preconizations,err){
          if(preconizations){
            parent.preconizations = preconizations;
            parent.showData(preconizations);
          }
          else{
            toastr.error("Impossible de récupérer les préconisations du questionnaire.","ERREUR");
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// show_actions.vue?a9739150